// extracted by mini-css-extract-plugin
module.exports = {"primary":"month-plan-next-entity_primary__pmIrc"};